import { ContentTitle } from "views/applications-id-report/components/ContentTitle";
import { KeyValue } from "views/applications-id-report/components/KeyValue";
import { PaystubDocumentPaystub } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified/paystub";

export const EmployeeInformationSlice = ({
  paystub
}: {
  paystub: PaystubDocumentPaystub;
}) => {
  return (
    <ContentTitle title="Employee information" contentClassName="space-y-2">
      <KeyValue
        label="Name"
        value={paystub.employee.name || "-"}
        flagEmpty
        flagTooltip="Important income data is missing"
      />
      <KeyValue
        label="Address line 1"
        value={paystub.employee.address.line1 || "-"}
      />
      <KeyValue
        label="Address line 2"
        value={paystub.employee.address.line2 || "-"}
      />
      <KeyValue label="City" value={paystub.employee.address.city || "-"} />
      <KeyValue
        label="State"
        value={paystub.employee.address.state_code || "-"}
      />
      <KeyValue
        label="Zip"
        value={paystub.employee.address.postal_code || "-"}
      />
      <KeyValue
        label="Marital status"
        value={paystub.employee.marital_status || "-"}
      />
      <KeyValue
        label="Tax ID Type"
        value={paystub.employee.taxpayer_id.id_type || "-"}
      />
      <KeyValue
        label="Last 4 Digits"
        value={paystub.employee.taxpayer_id.last_4_digits || "-"}
      />
    </ContentTitle>
  );
};
